import React, { useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

import EntityFormPage from "../../../../components/EntityFormPage/EntityFormPage";
import { ToastContext } from "../../../../App";
import { useCreateOrganizationMutation } from "../../../../redux/services/organization";
import { timezoneOptions } from "../../../../utils/timezoneOptions";

import * as styles from "../Organizations.module.css";

const LIST_PATH = "/app/admin/organizations";

function OrganizationCreatePage() {
  const showToast = useContext(ToastContext);
  const navigate = useNavigate();

  const { control, handleSubmit } = useForm({
    defaultValues: { name: "", subdomain: "", timezone: "" },
  });

  const [
    createOrganization,
    {
      isSuccess: isCreateOrganizationSuccess,
      isError: isCreateOrganizationError,
      error: createOrganizationError,
    },
  ] = useCreateOrganizationMutation();

  useEffect(() => {
    if (isCreateOrganizationSuccess) {
      showToast("success", "Organization", "Organization created!");
      navigate(LIST_PATH);
    }
  }, [isCreateOrganizationSuccess]);

  useEffect(() => {
    if (isCreateOrganizationError) {
      showToast(
        "error",
        createOrganizationError?.status,
        createOrganizationError?.data?.message ||
          (createOrganizationError?.data?.errors && "Incorrect data"),
      );
    }
  }, [isCreateOrganizationError]);

  const onCreate = (data) => {
    createOrganization({
      name: data.name,
      subdomain: data.subdomain,
      timezone: data.timezone,
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(onCreate)();
    }
  };

  return (
    <EntityFormPage
      title="New Organization"
      backTo={LIST_PATH}
      footer={
        <Button
          label="Save"
          type="submit"
          className={`p-button-success ${styles.saveBtn}`}
          onClick={handleSubmit(onCreate)}
        />
      }
    >
      <form onSubmit={handleSubmit(onCreate)}>
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label>Name</label>
              <InputText
                className={`w-full mb-3 ${styles.input}`}
                onKeyDown={handleKeyDown}
                placeholder="Name"
                {...field}
              />
            </div>
          )}
        />

        <Controller
          name="subdomain"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label>Subdomain</label>
              <InputText
                className={`w-full mb-3 ${styles.input}`}
                onKeyDown={handleKeyDown}
                placeholder="Subdomain"
                {...field}
              />
            </div>
          )}
        />

        <Controller
          name="timezone"
          control={control}
          render={({ field }) => (
            <div className={`field ${styles.dropDownWrapper}`}>
              <label>Timezone</label>
              <Dropdown
                id={field.name}
                value={field.value}
                onChange={(e) => field.onChange(e.value)}
                placeholder="Select timezone"
                className="w-full"
                panelClassName={styles.dropDownPanel}
                filter
                options={timezoneOptions}
              />
            </div>
          )}
        />

        <button type="submit" hidden />
      </form>
    </EntityFormPage>
  );
}

export default OrganizationCreatePage;
